<button mat-button (click)="onBack()">
  <div class="flex items-center flex-row gap-2 justify-center">
    <i class="icon">arrow_back</i>
    @if (!onlyArrow) {
    <span class="only-desktop d-b2">{{ 'navbar.backText' | translate }}</span>
    }
  </div>
</button>
